var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vf-uc",class:[
    { 'vf-selected' : _vm.selected }
],on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[(_vm.designer)?_c('div',[_vm._v(" "+_vm._s('Universal checkout')+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }